import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { obtenerDomiciliosCliente, obtenerTodasLasInstalacionesClientes, obtenerCliente } from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import TabLista from './ToolBarComponent/TabLista';
import TabContext from '@mui/lab/TabContext';
import TabPaneles from './ToolBarComponent/TabPaneles';

import DomiciliosComponent from './AnexosComponet/DomiciliosComponent';
import InstalacionesComponent from './AnexosComponet/InstalacionesComponent';
import TabsRelaciones from './RelacionesCliente/TabRelacionesComponet';
import TabsDatosGeneralesComponent from './AnexosComponet/DatosGeneralesComponent/TabsDatosGeneralesComponent';
import TabsPrediosViverosComponent from './AnexosComponet/PrediosViverosComponent/TabsPrediosViverosComponent';
import TabsMarcasComponent from './AnexosComponet/MarcasComponent/TabsMarcasComponent';
import TabsDocumentacionComponent from './AnexosComponet/DocumentacionComponent/TabsDocumentacionComponent'

function DetalleClienteComponent(props) {

    const detalleCliente = useSelector(store => store.ModuloConsulta.detalleCliente)
    const dataUser = useSelector(store => store.Usuario.user)
    const dispatch = useDispatch()

    const [value, setValue] = React.useState('datosGenerales');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }; 

    const [cliente, setCliente] = React.useState(detalleCliente);
    React.useEffect(async () => {
        let cliente = await dispatch(obtenerCliente(detalleCliente?.idcliente))
        await setCliente(cliente?.payload)
    }, [])

    const [domicilios, setDomicilios] = React.useState([]);
    const [isEdicionDomicilio, setIsEdicionDomicilio] = React.useState(false);

    React.useEffect(async () => {
        if (value == 'domicilios') {
            let domicilios = await dispatch(obtenerDomiciliosCliente(detalleCliente?.idcliente))
            setDomicilios(domicilios?.payload)
        }
        setIsEdicionDomicilio(false)
    }, [value, isEdicionDomicilio])

    const [instalaciones, setInstalaciones] = React.useState([]);
    const [isEdicionInstalaciones, setIsEdicionInstalaciones] = React.useState(false);

    React.useEffect(async () => {
        if (value == 'Instalaciones') {
            let instalaciones = await dispatch(obtenerTodasLasInstalacionesClientes(detalleCliente?.idcliente))
            setInstalaciones(instalaciones?.payload)
        }
        setIsEdicionInstalaciones(false)
    }, [value, isEdicionInstalaciones])


    return (
        <div className='container2 mt-1'>
            <div className='text-center'>
                <TabContext value={value}>
                    <TabLista value={value} handleChange={handleChange} data={detalleCliente} />

                    <TabPaneles value="datosGenerales">
                        <TabsDatosGeneralesComponent detalle={detalleCliente} setCliente={setCliente} cliente={cliente} />
                    </TabPaneles>

                    <TabPaneles value="domicilios">
                        {ordenarActivosASC(sortJSON(domicilios, 'isbaja', 'asc'), 'domicilios')?.map((domicilio, index) =>
                            <DomiciliosComponent data={domicilio} setIsEdicionDomicilio={setIsEdicionDomicilio} />
                        )}
                    </TabPaneles>

                    <TabPaneles value="viverosPredios">
                        <TabsPrediosViverosComponent detalle={detalleCliente} />
                    </TabPaneles>

                    <TabPaneles value="Instalaciones">
                        <div className='row'>
                            {ordenarActivosASC(sortJSON(instalaciones, 'isbaja', 'asc'), 'instalaciones')?.map((anexo, index) =>
                                <div key={index} className='col-12 col-md-12 mt-5'>
                                    <InstalacionesComponent data={anexo} setIsEdicionInstalaciones={setIsEdicionInstalaciones} />
                                </div>
                            )}
                        </div>
                    </TabPaneles>

                    <TabPaneles value="marcas">
                        <TabsMarcasComponent detalle={detalleCliente} />
                    </TabPaneles>

                    <TabPaneles value="relaciones">
                        <TabsRelaciones detalleCliente={detalleCliente} />
                    </TabPaneles>

                    <TabPaneles value="documentacion">
                        <TabsDocumentacionComponent detalle={detalleCliente} />
                    </TabPaneles>

                </TabContext>
            </div>
        </div>
    )
}
function sortJSON(data, key, orden) {
    // Crea una copia del arreglo usando el operador de propagación (spread operator)
    const dataCopy = [...data];

    return dataCopy.sort(function (a, b) {
        var x = a[key],
            y = b[key];

        if (orden === 'asc') {
            if (x === y) return 0;
            if (x === false) return -1;
            if (y === false) return 1;
            return 0;
        }

        if (orden === 'desc') {
            if (x === y) return 0;
            if (x === true) return -1;
            if (y === true) return 1;
            return 0;
        }
    });
}

function ordenarActivosASC(array, idName) {
    let activos = []
    let inactivos = []

    array?.map(item => {
        if (item?.isbaja == false) activos.push(item)
        else if (item?.isbaja == true) inactivos.push(item)
    })

    if (activos.length > 1) {
        if (idName == 'domicilios') activos.sort(((a, b) => a.iddomiciliofiscal - b.iddomiciliofiscal));
        else if (idName == 'instalaciones') activos.sort(((a, b) => a.idanexocliente - b.idanexocliente));
    }

    return activos.concat(inactivos);
}
export default DetalleClienteComponent
